export default __webpack_public_path__ + "static/media/fniris.026e537f.png";